import { ApolloLink } from '@apollo/client'

import { ROUTES } from '../../_routes/routes-list'
import { tokenService } from '../../auth/data'
import { UsersWorkspace } from '../../auth/data/auth-types'
import { selectedWorkspaceVar } from '../../auth/data/use-auth'

/**
 * Apollo Link that automatically adds the workspace ID header (ws-id)
 * when a selectedWorkspace is available, but ONLY on carrier onboarding pages.
 *
 * This complements the URL-based workspace detection in authMiddleware.
 */
export const onboardingMiddleware = new ApolloLink((operation, forward) => {
  let selectedWorkspace = selectedWorkspaceVar()

  // Get selectedWorkspace from local storage if not available
  if (!selectedWorkspace) {
    const storedWorkspace = tokenService.getLocalStoreData('selectedWorkspace') as UsersWorkspace | null
    if (storedWorkspace?.workspace?.id) {
      selectedWorkspace = storedWorkspace.workspace
    }
  }

  const path = window.location.pathname

  // Only apply this middleware on carrier onboarding routes
  const isCarrierOnboarding = path.includes(ROUTES.CARRIER_ONBOARDING)

  if (isCarrierOnboarding && selectedWorkspace) {
    const workspaceID = selectedWorkspace.id

    if (workspaceID) {
      const context = operation.getContext()
      const headers = context.headers || {}

      // Only add the ws-id if it's not already present
      if (!headers['ws-id']) {
        operation.setContext({
          ...context,
          headers: {
            ...headers,
            'ws-id': workspaceID
          }
        })
      }
    }
  }

  return forward(operation)
})
